import QuestionGeneratorHelper from './question_generator_helper.js'

function Question (params) {
    this.generator     = params.generator
    this.timeoutTime   = params.timeoutTime
    this.errorExpected = params.errorExpected
    this.dontGoBack    = params.dontGoBack
    this.times         = params.times || 1
    this.initialTimes  = this.times
    this.tries         = 0
    this.errors        = 0
}


Question.prototype.generate = function () {
    this.tries++
    const q = new QuestionGeneratorHelper()
    q.currentTry = this.tries
    this.generator(q)
    return q
}

export default Question

